import { useEffect, useState } from "react";
import axios from "axios";

const API = "/api";
const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

/**
 * Busca stats do funil de cardápio pra um período. `period` é uma das chaves
 * de PERIOD_OPTIONS ("today", "7d", "30d", "custom"). Quando "custom", `from`
 * e `to` precisam estar preenchidos (YYYY-MM-DD), senão a chamada é skipada.
 */
export function useFunnelStats({ period, from, to }) {
  const [stats, setStats] = useState(null);
  // Começa carregando: com false, a 1ª pintura mostrava o funil zerado e
  // "0,00% acima" antes da resposta (25/10/2026).
  const [loading, setLoading] = useState(true);
  // true depois da 1ª resposta (boa ou não): decide o esqueleto da 1ª abertura.
  const [carregou, setCarregou] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetch = async () => {
      if (period === "custom" && (!from || !to)) {
        // Sem isso, trocar para Personalizado com a busca anterior em andamento
        // deixava "Atualizando…" para sempre (o cancelamento pulava o finally).
        setLoading(false);
        setCarregou(true);
        return;
      }
      setLoading(true);
      try {
        const params = { period };
        if (period === "custom") {
          params.from_date = from;
          params.to_date = to;
        }
        const res = await axios.get(`${API}/cardapio-funnel/stats`, { ...auth(), params });
        if (!cancelled) setStats(res.data);
      } catch {
        if (!cancelled) setStats(null);
      } finally {
        if (!cancelled) {
          setLoading(false);
          setCarregou(true);
        }
      }
    };
    fetch();
    return () => {
      cancelled = true;
    };
  }, [period, from, to]);

  return { stats, loading, carregou };
}
